import { apiService } from '../services/api';
import { NameCollisionError, isRateLimited } from './apiError';
import { getTimezoneOffsetMinutes } from './timezone';

export interface PersistSlot {
  day: string;
  hour: number;
}

export async function persistSlotUpdates(options: {
  roomId: string;
  participantName: string;
  browserFingerprint: string;
  slots: PersistSlot[];
  available: boolean;
  onNameReassigned?: (name: string) => void;
}): Promise<{ failed: PersistSlot[]; rateLimited: boolean; participantName: string }> {
  const { roomId, browserFingerprint, slots, available, onNameReassigned } = options;
  let participantName = options.participantName;
  const tz = getTimezoneOffsetMinutes();
  const failed: PersistSlot[] = [];
  let rateLimited = false;

  const write = (name: string, slot: PersistSlot) =>
    apiService.updateAvailability(
      roomId,
      name,
      slot.day,
      slot.hour,
      available,
      browserFingerprint,
      tz
    );

  await Promise.all(
    slots.map(async slot => {
      try {
        await write(participantName, slot);
      } catch (err) {
        if (err instanceof NameCollisionError) {
          participantName = err.assignedName;
          onNameReassigned?.(err.assignedName);
          try {
            await write(err.assignedName, slot);
            return;
          } catch (retryErr) {
            if (isRateLimited(retryErr)) rateLimited = true;
            failed.push(slot);
            return;
          }
        }
        if (isRateLimited(err)) rateLimited = true;
        failed.push(slot);
      }
    })
  );

  return { failed, rateLimited, participantName };
}
